<template>
    <div class="col-sm-12">
        <div class="row mb-3">
            <div class="col-8">
                <input
                    v-model="searchQuery"
                    type="text"
                    class="form-control"
                    :placeholder="$t('subscription.search_company')"
                />
            </div>
            <div class="col-4">
                <div class="form-check form-switch">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="activeSubscriptionsCheckbox"
                        v-model="showActiveOnly"
                    />
                    <label class="form-check-label ms-2" for="activeSubscriptionsCheckbox">
                        {{ $t('subscription.only_active_subscriptions') }}
                    </label>
                </div>
            </div>
        </div>
        <Transition name="fade">
            <div v-if="allItems.length > 0" class="col-sm-12 list-content result-table nopads">
                <vue3-datatable
                    ref="resultTable"
                    :rows="filteredItems"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    height="100%"
                    :sortable="true"
                    :sortColumn="'company'"
                    :sortDirection="'asc'"
                    skin="bh-table-compact"
                    :row-class="getRowClass"
                    cell-class="routa-table-cell"
                    :hasCheckbox="false"
                    @row-click="emitEdit"
                >
                    <template #route_optimization="{ value }">
                        <font-awesome-icon
                            v-if="value.route_optimization"
                            icon="check"
                            :style="{color: '#28a745'}"
                        />
                        <font-awesome-icon
                            v-else
                            icon="times"
                            :style="{color: '#6c757d'}"
                        />
                    </template>
                    <template #chat="{ value }">
                        <font-awesome-icon
                            v-if="value.chat"
                            icon="check"
                            :style="{color: '#28a745'}"
                        />
                        <font-awesome-icon
                            v-else
                            icon="times"
                            :style="{color: '#6c757d'}"
                        />
                    </template>
                    <template #dash_cam="{ value }">
                        <font-awesome-icon
                            v-if="value.dash_cam"
                            icon="check"
                            :style="{color: '#28a745'}"
                        />
                        <font-awesome-icon
                            v-else
                            icon="times"
                            :style="{color: '#6c757d'}"
                        />
                    </template>
                </vue3-datatable>
            </div>
        </Transition>
    </div>
</template>

<script>
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'SubscriptionsList',
    components: {Vue3Datatable},
    props: {
        results: {
            type: Array,
            default: () => []
        }
    },
    emits: ['edit'],
    data() {
        return {
            fields: [
                {field: 'company', title: this.$t('subscription.company'), sort: true, headerClass: 'routa-table-header'},
                {field: 'route_optimization', title: this.$t('subscription.route_optimization'), sort: false, headerClass: 'routa-table-header'},
                {field: 'chat', title: this.$t('subscription.chat'), sort: false, headerClass: 'routa-table-header'},
                {field: 'dash_cam', title: this.$t('subscription.dash_cam'), sort: false, headerClass: 'routa-table-header'}
            ],
            showActiveOnly: false,
            searchQuery: '',
            allItems: []
        }
    },
    computed: {
        filteredItems() {
            let items = this.allItems;
            if (this.showActiveOnly) {
                items = items.filter(item =>
                    item.route_optimization ||
                    item.chat ||
                    item.dash_cam
                );
            }
            if (this.searchQuery.trim()) {
                items = items.filter(item =>
                    item.company.toLowerCase().includes(this.searchQuery.toLowerCase())
                );
            }
            return items;
        }
    },
    watch: {
        results() {
            this.updateTableItems();
        }
    },
    mounted() {
        this.updateTableItems();
    },
    methods: {
        updateTableItems() {
            this.allItems = this.results.map(item => {
                return {
                    id: item.company?.id,
                    company: item.company?.name || '-',
                    route_optimization: item.route_optimization?.is_active === true,
                    chat: item.chat?.is_active === true,
                    dash_cam: item.dash_cam?.is_active === true
                };
            });
        },

        emitEdit(result) {
            const item = this.results.find(item => item.company?.id === result.id);
            if (item) {
                this.$emit('edit', item);
            }
        },

        getRowClass(item) {
            return item.route_optimization ? 'routa-table-row active-subscription' : 'routa-table-row inactive-subscription';
        }
    }
}
</script>

<style>
.routa-table-cell {
    text-align: center;
}
.routa-table-cell:first-child {
    text-align: left;
}
.active-subscription {
    background-color: #d4edda !important;
}
.inactive-subscription {
    background-color: #f8f9fa !important;
}
</style>
